import { formatINR } from "@/lib/api";

export const StatCard = ({ label, value, accent = "neutral", hint, testId }) => {
  const colorMap = {
    credit: "text-[#1F4E3D]",
    debit: "text-[#D26A59]",
    neutral: "text-[#212421]",
    warning: "text-[#E8B253]",
  };
  return (
    <div
      data-testid={testId}
      className="bg-white border border-[#EAE8E3] rounded-lg p-6 transition-all hover:-translate-y-0.5 hover:shadow-md"
    >
      <div className="label-overline mb-3">{label}</div>
      <div className={`font-mono-num text-3xl sm:text-4xl tracking-tight ${colorMap[accent]}`}>
        ₹{formatINR(value)}
      </div>
      {hint && <div className="mt-2 text-xs text-[#696E69]">{hint}</div>}
    </div>
  );
};
